








































































// tslint:disable-next-line:no-unused
import Vue, { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { Slots } from '@vue/test-utils';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { dropdown, DropdownDirValues } from '@sonicwall/unified-ui-framework/src/shared/dropdown-dir';
// import { utilService } from '@sonicwall/unified-ui-framework/src/shared/util-service';
import DropdownThreeComponentUnit from './dropdown-three-component-unit.vue';
import { RootStoreState } from '../../store';
import { State } from 'vuex-class';
import { DropdownStoreState } from './dropdown-store';
import { dropdownThreeComponentEventBus } from '.';
import { defaultSelectedCustomer } from '@/modules/msw-products/products.store';
// tslint:disable-next-line:no-unused

// tslint:disable-next-line:no-unused
const cssPrefix: string = 'dropdown-three-component';

// @ts-ignore
@Component({
  directives: {
    dropdown,
  },
  components: {
    SwIcon,
    DropdownThreeComponentUnit,
  },
})
export default class SwDropDownThreeComponent extends SwExtendedVue{
  cssPrefix = cssPrefix;
  customersList: any[] = [{ productGroupName: defaultSelectedCustomer, productGroupId: '' }];
  dropdownOpen: boolean = false;
  slots: Slots;
  searchValueToBeEmitted: string = '';
  searchedValue: any;

  @State((state: RootStoreState) =>  state.DropdownStore.searchValues)
  searchValues: DropdownStoreState['searchValues'];

  @Prop({ required: true, type: [String, Number, Boolean] })
  dropdownLabel: string | number | boolean;

  @Prop({ default: '206px' })
  width: string;

  divStyle = {
    // tslint:disable-next-line:prefer-template
    width: this.width + 'px',
  };

  dropdownStyle = {
    // tslint:disable-next-line:prefer-template
    width: this.width + 'px',
    height: '434px',
    overflow: 'unset',
  };

  get getDivWidth() {
    // tslint:disable-next-line:prefer-template
    return this.divStyle;
  }

  // tslint:disable-next-line:no-unused
  clickOutside(e: EventListener) {
  }

  dropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  get focusPopoverValue(): DropdownDirValues {
    // tslint:disable-next-line:block-spacing
    return {
      /* tslint:disable */
      content: (h:CreateElement) => {
        return (
          <div ref="dropdowncontainerRef" class="dropdown-three-component__container" style="{this.dropdownStyle}">
            <div class="dropdown-three-component__searchbar-container" style="width:206px; height: 400px; padding:10px; padding-top:10px">
              <DropdownThreeComponentUnit customersList={this.customersList}></DropdownThreeComponentUnit> 
            </div>
          </div>
        ) as VNode;
      },
      trigger: 'controlled',
      visible: this.dropdownOpen,
      placement: 'bottom',
      withArrow: false,
      maxHeight: 434,
      onClickOutsidePopper: ()=>{this.dropdownOpen = false},
    };
  }

  customerChanged(prp: any) {
  }

  getCustomersList() {
    this.$store.commit('startLoading');
    if (this.$store.getters.isLargeCustomer) {
      this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets')
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.prodGroupLicenseStatus) {
          res.prodGroupLicenseStatus.forEach((element : any)  => {
            this.customersList.push({
              productGroupName: element.productGroupName,
              productGroupId: element.productGroupId,
              sharedGroup: element.sharedGroup || '',
              sharedGroupHoverText: element.sharedGroupHoverText || '',
            });
          });
          this.$emit('customerListEmitter', res.prodGroupLicenseStatus);
        }
      });
    } else {
      this.$store.dispatch('MswProductsStoreModule/getCustomerName', 'dropDown')
      .then((res) => {
        this.$store.commit('stopLoading');
        if (res.productGroup) {
          res.productGroup.forEach((element : any)  => {
            this.customersList.push({
              productGroupName: element.productGroupName,
              productGroupId: element.productGroupId,
              sharedGroup: element.sharedGroup || '',
              sharedGroupHoverText: element.sharedGroupHoverText || '',
            });
          });
          this.$emit('customerListEmitter', res.productGroup);
        }
      });
    }
  }

  mounted() {
    this.searchedValue = dropdownThreeComponentEventBus.$on('clicked-show-recent', ( { selectedVal ,productGroupId} : any ) => { 
      this.searchValueToBeEmitted = selectedVal;
      this.dropdownOpen = !this.dropdownOpen;
      this.$emit('searchValueEmitter', { selectedVal ,productGroupId });
    return selectedVal;
  });
  }

  created() {
    this.getCustomersList();
  }
}
